import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ButtonDirective } from 'primeng/button';
import { SaveErrorService } from '../../services/save-error.service';

/**
 * Surfaces autosave failures (PRO-209) so they can never go unnoticed the way
 * they used to — a 413/500/network error used to be swallowed silently,
 * leaving the user editing on top of work that was never persisted.
 *
 * Deliberately *not* a hard block: a first/renewed failure shows a
 * full-screen warning the user must acknowledge, but dismissing it doesn't
 * clear the underlying error — a persistent banner stays up, and the
 * full-screen warning re-appears on the next failed save once the
 * re-escalation cooldown in `SaveErrorService` has passed.
 */
@Component({
	selector: 'app-save-error-overlay',
	imports: [ButtonDirective],
	templateUrl: './save-error-overlay.html',
	styleUrl: './save-error-overlay.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SaveErrorOverlayComponent {
	protected saveErrorService = inject(SaveErrorService);
}
